<template>
  <div class="mainContent grid">
    <div class="page-block u-16 fixedfilter">
      <VisualSearch
        v-on:loadAsyncData="loadAsyncData"
        v-on:saveSearchParams="saveSearchParams"
        :merchantList="merchantList"
        :terminalList="terminalList"
        :processingList="processingList"
        :statusList="statusList"
        :decisionList="decisionList"
        :isReport="isReport"
        :isSplits="isSplits"
        :loading="loading"
      />
      <div class="grid cross-center between table-controls">
        <div>
          <b-field>
            <b-dropdown>
              <button class="button button-white" slot="trigger">
                <b-icon icon="settings-outline" size="is-small"></b-icon>
                <span>Управление столбцами</span>
              </button>
              <div
                v-bar="{
                  preventParentScroll: true,
                  scrollThrottle: 5,
                  draggerThrottle: 5
                }"
              >
                <div class="vuebar">
                  <b-dropdown-item
                    custom
                    v-for="(column, index) in controlColumns"
                    :key="index"
                  >
                    <div class="control">
                      <b-checkbox
                        v-model="column.visible"
                        size="is-small"
                        @input="saveColumns()"
                        >{{ column.title }}</b-checkbox
                      >
                    </div>
                  </b-dropdown-item>
                </div>
              </div>
            </b-dropdown>
            <b-switch
              size="is-small"
              v-model="OnebyOne"
              class="onebyone"
              type="is-info"
              >Открывать по-одному</b-switch
            >
          </b-field>
        </div>
        <div class="grid cross-center between table-title">
          <div>
            <el-button
              icon="el-icon-refresh"
              type="primary"
              plain
              @click="refreshOrders()"
              :loading="loading"
              >Обновить</el-button
            >
          </div>
        </div>
      </div>
    </div>

    <div class="main-table u-16">
      <div
        v-show="direction == 'up' && loading"
        class="padding-5 loading-block loadtop"
      >
        <span>Загрузка заказов...</span>
      </div>
      <VuePerfectScrollbar class="scroll-area" :settings="scrollsettings">
        <b-table
          :data="data"
          custom-row-key="id"
          :loading="loading"
          :has-detailed-visible="() => true"
          detailed
          @details-open="expandRow"
          narrowed
          :opened-detailed="openedDetailed"
          detail-key="id"
          :row-class="rowClassDetails"
          mobile-cards
          :default-sort="[sortField, sortOrder]"
          :default-sort-direction="defaultSortOrder"
          @click="expandRow"
          ref="tableOrders"
          class="orders"
        >
          <template slot-scope="props">
            <b-table-column
              field="id"
              label="id"
              sortable
              :visible="getProfile.is_admin"
              >{{ props.row.id }}</b-table-column
            >
            <b-table-column
              field="merchant_order_id"
              label="№ заказа продавца"
              sortable
              visible
              >{{ props.row.merchant_order_id }}</b-table-column
            >
            <b-table-column
              field="date_created"
              width="130"
              label="Дата"
              sortable
              >{{ props.row.date_created | momentFormat() }}</b-table-column
            >
            <b-table-column field="terminal_id" label="Терминал" sortable>
              {{ terminalName(props.row.terminal_id) }}
            </b-table-column>
            <b-table-column field="amount" label="Сумма" sortable numeric>
              {{ props.row.amount | amountFormat }}
              {{ currencyCharacter(props.row.currency_code) }}
            </b-table-column>
            <b-table-column
              field="state_id"
              label="Статус"
              sortable
              class="status"
            >
              <span
                class="status-tag"
                :class="statusStyle(props.row.state_id)"
                >{{ statusName(props.row.state_id) }}</span
              >
            </b-table-column>
            <b-table-column
              v-for="(column, index) in controlColumns"
              :key="index"
              :label="column.title"
              :visible="column.visible"
              :centered="column.centered"
              :width="column.width"
            >
              <el-tooltip
                v-if="
                  column.field == 'payment_type' &&
                    (props.row.card_holder == 'APPLE PAY' ||
                      props.row.card_holder == 'GOOGLE PAY')
                "
                class="item"
                effect="dark"
                placement="top"
                transition="el-zoom-in-bottom"
                :open-delay="300"
              >
                <div slot="content">{{ props.row.card_holder }}</div>
                <img
                  class="payment-type r-margin-5"
                  :src="holderImg(props.row.card_holder)"
                  alt
                />
              </el-tooltip>

              <el-tooltip
                v-if="column.field == 'payment_type' && !props.row.is_ips"
                class="item"
                effect="dark"
                placement="top"
                transition="el-zoom-in-bottom"
                :open-delay="300"
              >
                <div slot="content">{{ cardName(props.row.card_type_id) }}</div>
                <span
                  class="card-type"
                  :class="cardClass(props.row.card_type_id)"
                ></span>
              </el-tooltip>

              <img
                v-if="column.field == 'payment_type' && props.row.is_ips"
                class="payment-type"
                :src="holderImg('IPS')"
                alt
              />
              <img
                class="processing-icon"
                v-if="column.field == 'processing_id'"
                :src="processingIcon(props.row[column.field])"
                alt
              />

              <span
                v-if="
                  column.field == 'antifraud_decision' &&
                    props.row.antifraud_decision != null
                "
                class="status-tag"
                :class="decisionStyle(props.row.antifraud_decision)"
                >{{ decisionName(props.row.antifraud_decision) }}</span
              >

              <el-tooltip
                v-if="
                  column.field == 'ip' &&
                    imgSrc(props.row.ip_country_code) != ''
                "
                class="item"
                effect="dark"
                placement="top"
                transition="el-zoom-in-bottom"
                :open-delay="300"
              >
                <div slot="content">
                  {{ countryNameRu(props.row.ip_country_code) }}
                </div>
                <img
                  class="flag-icon"
                  :src="imgSrc(props.row.ip_country_code)"
                />
              </el-tooltip>

              <i
                class="el-icon-check"
                v-if="
                  (column.field == 'is_split' ||
                    column.field == 'is_recurrent' ||
                    column.field == 'is_receipt') &&
                    props.row[column.field]
                "
              ></i>
              <i
                class="el-icon-minus"
                v-if="
                  (column.field == 'is_split' ||
                    column.field == 'is_recurrent' ||
                    column.field == 'is_receipt') &&
                    !props.row[column.field]
                "
              ></i>
              {{
                column.field == "processing_id"
                  ? processingName(props.row[column.field])
                  : column.field == "is_split"
                  ? ""
                  : column.is_cp == true
                  ? getCustomParams(
                      column.field,
                      props.row.custom_params,
                      props.row.id
                    )
                  : column.field == "card_holder" &&
                    (props.row.card_holder == "APPLE PAY" ||
                      props.row.card_holder == "GOOGLE PAY")
                  ? ""
                  : column.field == "antifraud_decision"
                  ? ""
                  : column.field == "is_recurrent" ||
                    column.field == "is_receipt"
                  ? ""
                  : column.field == "merchant_id"
                  ? merchantName(props.row[column.field])
                  : props.row[column.field]
              }}
            </b-table-column>
          </template>

          <template slot="detail" slot-scope="props">
            <div class="grid">
              <b-field
                grouped
                group-multiline
                class="u-16 grid padding-20 order-actions"
                v-if="showOptionButtons(props.row.state_id)"
              >
                <!-- Charge -->
                <div
                  v-if="
                    props.row.state_id == 3 &&
                      (getProfile.is_admin == true ||
                        !(getRights.indexOf('charge') == -1))
                  "
                >
                  <button
                    class="button button-white"
                    @click="
                      openChargeDialog(
                        props.row.id,
                        props.row.amount,
                        props.row.currency_code
                      )
                    "
                  >
                    <b-icon icon="credit-card" custom-size="mdi-18px"></b-icon>
                    <span>Списать</span>
                  </button>
                </div>
                <!-- Unlock -->
                <div
                  v-if="
                    props.row.state_id == 3 &&
                      (getProfile.is_admin == true ||
                        !(getRights.indexOf('unblock') == -1))
                  "
                >
                  <unlockDialog
                    :transaction_id="props.row.id"
                    :amountOrder="props.row.amount"
                    :currency="currencyCharacter(props.row.currency_code)"
                    v-on:loadAsyncData="loadAsyncData"
                  />
                </div>
                <!-- Refund -->
                <div
                  v-if="
                    (props.row.state_id == 8 || props.row.state_id == 20) &&
                      (getProfile.is_admin == true ||
                        !(getRights.indexOf('refund') == -1))
                  "
                >
                  <refundDialog
                    :key="props.row.id"
                    :transaction_id="props.row.id"
                    :amountOrder="props.row.amount"
                    :orderCP="getListOfCP(props.row.id)"
                    :isSplit="props.row.is_split"
                    :merchantOrderId="props.row.merchant_order_id"
                    :splitList="
                      getListofSplit(props.row.id, props.row.state_id)
                    "
                    :isReceipt="props.row.is_receipt"
                    :terminalTax="terminalTax(props.row.terminal_id)"
                    :orderGoods="getListOfGoods(props.row.id)"
                    :currency="currencyCharacter(props.row.currency_code)"
                    v-on:loadAsyncData="loadAsyncData"
                  />
                </div>

                <!-- Change state -->
                <changeStatusDialog
                  v-if="
                    getProfile.is_admin == true ||
                      !(getRights.indexOf('state_change') == -1)
                  "
                  :transaction_id="props.row.id"
                  :disable_update_state="props.row.disable_update_state"
                  :statusList="statusList"
                  v-on:loadAsyncData="loadAsyncData"
                />

                <!-- actualize state -->
                <actualize-state
                    v-if="
                      getProfile.is_admin == true ||
                        !(getRights.indexOf('actualize_transaction') == -1)
                    "
                    :transaction_id="props.row.id"
                    v-on:loadAsyncData="refreshOrders"
                />

              </b-field>
              <div class="content u-16 grid">
                <!-- Order information -->
                <OrderInfo
                  :rowId="props.row.id"
                  :orderCP="getListOfCP(props.row.id)"
                  :orderGoods="getListOfGoods(props.row.id)"
                  :isReceipt="props.row.is_receipt"
                  :title="'Информация о заказе'"
                  :showCP="true"
                  :transactionInfo="getTransaction(props.row.id)"
                  :merchantName="merchantName(props.row.merchant_id)"
                  :terminalName="terminalName(props.row.terminal_id)"
                  :cardId="props.row.card_type_id"
                ></OrderInfo>
                <div
                  class="u-16 u-8-ss hor-padding-20-ss hor-padding-5 grid between multicross-start"
                >
                  <!-- Status history -->
                  <status-history
                    :key="props.row.id"
                    :orderTraces="getListOfTrace(props.row.id)"
                    :orderInfo="props.row"
                    v-if="
                      props.row.antifraud_decision != -1 &&
                        props.row.antifraud_decision != 1
                    "
                  ></status-history>

                  <!-- Antifraud Rules -->
                  <antifraud-rules
                    v-if="
                      props.row.antifraud_decision != null &&
                        (getProfile.is_admin == true ||
                          !(getRights.indexOf('antifraud_rules_view') == -1))
                    "
                    :afruleList="getListofRules(props.row.id)"
                  ></antifraud-rules>

                  <!-- OrderSplit -->
                  <OrderSplit
                    :key="'split' + props.row.id"
                    :orderSplit="
                      getListofSplit(props.row.id, props.row.state_id)
                    "
                    :currencyCode="props.row.currency_code"
                    v-if="props.row.is_split"
                  ></OrderSplit>
                </div>
              </div>
            </div>
          </template>

          <template slot="empty">
            <section class="empty-table">
              <div class="content ver-padding-50 has-text-centered">
                <p>{{ emptyDataTable }}</p>
              </div>
            </section>
          </template>
        </b-table>
      </VuePerfectScrollbar>
      <div
        v-show="direction == 'down' && loading"
        class="padding-5 loading-block loadbot"
      >
        <span>Загрузка заказов...</span>
      </div>
    </div>
    <chargeDialog
      :showDialogCharge.sync="showDialogCharge"
      :transactionInfo="chargeTransactionInfo"
      v-on:loadAsyncData="loadTransactionById"
      v-on:closeChargeDialog="closeChargeDialog"
    />
  </div>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import { apiUrl } from "@/api/apiUrl";

import { mapGetters } from "vuex";

import "buefy/dist/buefy.css";

import VisualSearch from "@/components/VisualSearch";
import OrderInfo from "@/components/OrderInfo";
import StatusHistory from "@/components/StatusHistory";
import AntifraudRules from "@/components/AntifraudRules";
import OrderSplit from "@/components/OrderSplit";

import refundDialog from "@/components/orderActions/refundDialog";
import chargeDialog from "@/components/orderActions/chargeDialog";
import unlockDialog from "@/components/orderActions/unlockDialog";
import changeStatusDialog from "@/components/orderActions/changeStatusDialog";
import actualizeState from "@/components/orderActions/actualizeState";

import moment from "moment";
import axios from "axios";
import VueAxios from "vue-axios";
import { _ } from "vue-underscore";
Vue.use(VueAxios, axios);

import Vuebar from "vuebar";
Vue.use(Vuebar);

import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ActualizeState from "../components/orderActions/actualizeState";

export default {
  name: "Orders",
  props: ["row"],
  data() {
    return {
      isReport: false,
      isSplits: false,
      data: [],
      total: 0,
      totalSumm: 0,
      sortField: "Date",
      sortOrder: "desc",
      defaultSortOrder: "desc",
      openedDetailed: [],
      OnebyOne: true,
      loading: false,
      ordersLoading: 25,
      defParam: {
        id: -1,
        limit: 20,
        offset: 0,
        order_by: "id",
        order: "desc"
      },
      searchParams: {},
      customP: [],
      flag_cp: false,
      columnsTemplate: [
        {
          title: "Предприятие",
          field: "merchant_id",
          visible: false,
          centered: false
        },
        {
          title: "Держатель карты",
          field: "card_holder",
          visible: true,
          centered: false
        },
        {
          title: "Тип оплаты",
          field: "payment_type",
          visible: true,
          centered: true
        },

        {
          title: "Номер карты",
          field: "pan_mask",
          visible: true,
          centered: false,
          width: "200"
        },
        {
          title: "Процессинг",
          field: "processing_id",
          visible: true,
          centered: false,
          width: "200"
        },
        {
          title: "Код авторизации",
          field: "auth_code",
          visible: false,
          centered: false
        },
        { title: "RRN", field: "rrn", visible: false, centered: false },
        {
          title: "IP",
          field: "ip",
          visible: false,
          centered: false,
          width: "160"
        },
        {
          title: "Решение АФ",
          field: "antifraud_decision",
          visible: true,
          centered: false,
          width: "150"
        },
        {
          title: "Рекуррент",
          field: "is_recurrent",
          visible: false,
          centered: true
        },
        { title: "Сплиты", field: "is_split", visible: false, centered: true },
        {
          title: "Причина отказа",
          field: "processing_error_code",
          visible: false,
          centered: false
        },
        {
          title: "Чек",
          field: "is_receipt",
          visible: false,
          centered: true
        },
        {
          title: "Банк-Эмитент",
          field: "bank_name",
          visible: false,
          centered: false
        }
      ],
      transactionInfo: [],
      traceList: {},
      rulesList: {},
      splitList: {},
      paramList: {},
      goodsList: {},
      dialogRefund: false,
      dialogChangeStatus: false,
      showColumn: false,
      scrollsettings: {
        suppressScrollY: false
      },
      bottom: false,
      top: false,
      direction: "",
      hasDelOrders: false,
      delCount: 0,
      scrollValue: 0,
      scrollFromTop: false,
      isRefresh: false,
      chargeTransactionInfo: {},
      showDialogCharge: false
    };
  },
  methods: {
    saveSearchParams(params) {
      if (params != undefined) this.searchParams = params;
    },
    refreshOrders() {
      this.isRefresh = true;
      this.bottom = false;
      this.top = false;
      this.data = [];
      this.delCount = 0;
      this.defParam.offset = 0;
      this.defParam.limit = 20;
      this.defParam.order = "desc";
      this.defParam = _.omit(this.defParam, ["order_id_down", "order_id_up"]);
      this.loadAsyncData(undefined, "refresh");
    },
    loadAsyncData(params, action) {
      this.data = params ? [] : this.data;
      let paramRequest = {};
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      if (params) {
        this.defParam.offset = 0;
        this.bottom = false;
        this.top = false;
        this.defParam = _.omit(this.defParam, ["order_id_down", "order_id_up"]);
        paramRequest = Object.assign({}, this.defParam, params);
      } else {
        paramRequest = Object.assign({}, this.defParam, this.searchParams);
      }

      this.loading = true;
      // this.openedDetailed = [];
      axios
        .post(apiUrl + "transaction", paramRequest, config)
        .then(({ data }) => {
          if (data.list) {
            let newdata = data.list;
            newdata.forEach(el => (el.is_opened = false));

            if (!this.isReport) {
              if (action && action == "loadbot") {
                Array.prototype.push.apply(this.data, newdata);
                if (this.data.length >= 100) {
                  this.delCount += 1;
                  this.data.splice(0, this.defParam.limit);
                  window.scrollTo({
                    top: document.body.scrollHeight + 942
                  });
                }
              } else if (action && action == "loadtop") {
                if (this.delCount > 0) {
                  this.delCount -= 1;
                  this.data.splice(
                    this.data.length - this.defParam.limit,
                    this.defParam.limit
                  );
                  window.scrollTo({
                    top: document.body.scrollHeight - 88
                  });
                }
                this.data = newdata.reverse().concat(this.data);
              } else {
                this.delCount = 0;
                if (this.data.length == 0) this.data = newdata;
              }
            } else {
              this.data = newdata;
            }
          } else {
            if (!this.bottom)
              this.$message({
                message: "По вашему запросу ничего не найдено",
                type: "info",
                duration: 2000
              });
          }
          this.loading = false;
        })
        .catch(error => {
          this.data = [];
          this.loading = false;
          this.$message.error("Запрос не обработан");
          throw error;
        });
    },
    loadTransactionById(id) {
      this.loading = true;
      const config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      axios
        .post(apiUrl + "transaction", { id }, config)
        .then(({ data }) => {
          let index = this.data.findIndex(el => el.id == id);
          let transaction = data.list[0];
          if (index != -1) {
            this.$set(this.data, index, transaction);
            this.getTrace(id);
            if (transaction.is_receipt) this.getGoods(id);
            this.loading = false;
          }
        })
        .catch(error => {
          console.log(error.response);
          this.loading = false;
          this.$message.error(error.response);
        });
    },
    getTransaction(id) {
      var order = _.omit(
        _.findWhere(this.data, { id: id }),
        "is_opened",
        "id",
        "active",
        "is_payout",
        "is_split",
        "is_apple_pay",
        "processing_order_id",
        "state_id",
        "card_type_code",
        "card_type_id",
        "card_type_name",
        "bank_city"
      );
      let date_created = moment.utc(order["date_created"]);
      order["date_created"] = moment(date_created)
        .local()
        .format("DD.MM.YY HH:mm:ss");
      let date_updated = moment.utc(order["date_updated"]);
      order["date_updated"] = moment(date_updated)
        .local()
        .format("DD.MM.YY HH:mm:ss");

      var transactionInfo = { info: [], customParams: "" };
      for (var key in order) {
        if (
          (order[key] != "" && order[key] != null && order[key] != undefined) ||
          key == "ip_country_code" ||
          key == "bank_name" ||
          key == "bank_country_code" ||
          key == "is_recurrent"
        ) {
          if (key == "custom_params") {
            transactionInfo["customParams"] = order[key];
          } else if (key == "ip_country_code" || key == "bank_country_code") {
            transactionInfo[key] = order[key];
          } else {
            var row = {
              field: key,
              data: order[key]
            };
            transactionInfo["info"].push(row);
          }
        }
      }
      return transactionInfo;
    },
    getTrace(id) {
      var params = {
        transaction_id: id,
        offset: 0,
        order_by: "id",
        order: "desc"
      };
      var config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      let list = [];
      let obj = {};
      var flag = false;
      axios
        .post(apiUrl + "trace", params, config)
        .then(({ data }) => {
          if (data.state_id == 0 && data.total > 0) {
            data.list.forEach(item => {
              var state = item.processing_state_id;
              if (
                state == 2 ||
                state == 5 ||
                state == 7 ||
                state == 9 ||
                state == 11 ||
                state == 13 ||
                state == 15
              ) {
                item.isShow = false;
              } else {
                item.isShow = true;
              }
              if (item.created_by != null) flag = true;
              list.push(item);
            });
          }
          this.showColumn = flag;
        })
        .catch(err => {
          list = [];
          throw err;
        });
      this.traceList[id] = list;
    },
    getListOfTrace(id) {
      return this.traceList[id];
    },
    getCP(id) {
      if (this.paramList.hasOwnProperty(id)) return false;
      let params = {
        transaction_id: id
      };
      let config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      let list = [];
      axios
        .post(apiUrl + "transaction/param", params, config)
        .then(({ data }) => {
          if (data.state_id == 0 && data.total > 0) {
            data.list.forEach(item => {
              list.push(item);
            });
          }
        })
        .catch(err => {
          list = [];
          throw err;
        });
      this.paramList[id] = list;
    },
    getListOfCP(id) {
      return this.paramList[id];
    },
    getGoods(id) {
      let params = {
        transaction_id: id
      };
      let config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      let list = [];
      axios
        .post(apiUrl + "goods", params, config)
        .then(({ data }) => {
          if (data.state_id == 0 && data.total > 0) {
            data.list.forEach(item => {
              list.push(item);
            });
          }
        })
        .catch(err => {
          list = [];
          throw err;
        });
      this.goodsList[id] = list;
    },
    getListOfGoods(id) {
      return this.goodsList[id];
    },
    getAFRules(id) {
      var params = {
        transaction_id: id
      };
      var config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      let list = [];
      axios
        .post(apiUrl + "transaction/rule", params, config)
        .then(({ data }) => {
          if (data.state_id == 0 && data.total > 0) {
            data.list.forEach(item => {
              list.push(item);
            });
          }
        })
        .catch(err => {
          list = [];
          throw err;
        });
      this.rulesList[id] = list;
    },
    getListofRules(id) {
      return this.rulesList[id];
    },
    getSplit(id) {
      let params = {
        transaction_id: id,
        offset: 0,
        order_by: "id",
        order: "desc"
      };
      let config = {
        headers: {
          "Authorization-Token": localStorage.getItem("Authorization-Token")
        }
      };
      var orderSplit = [];
      axios
        .post(apiUrl + "split", params, config)
        .then(({ data }) => {
          if (data.state_id === 0 && data.total > 0) {
            data.list.forEach(item => {
              orderSplit.push(item);
            });
          }
        })
        .catch(err => {
          orderSplit = [];
          throw err;
        });
      this.$set(this.splitList, id, orderSplit);
    },
    getListofSplit(id, transactionStateId) {
      let list = [];
      if (this.splitList.hasOwnProperty(id)) {
        list =
          transactionStateId &&
          (transactionStateId === 3 ||
            transactionStateId === 8 ||
            transactionStateId === 10 ||
              transactionStateId === 20)
            ? this.splitList[id].filter(
                el => el.state_id === transactionStateId
              )
            : this.splitList;
      }
      return list;
    },
    expandRow(row) {
      if (this.OnebyOne) {
        // check open details one by one
        if (row.is_opened == true) {
          this.closeRow(row);
        } else {
          var oldOpened = this.openedDetailed;
          this.data.forEach(item => {
            if (item.id == oldOpened) {
              item.is_opened = false;
              this.closeRow(item);
            }
          });
          this.openedDetailed = [row.id];
          row.is_opened = true;
          this.loadOrderInfo(row);
        }
      } else {
        if (!row.is_opened) {
          this.openedDetailed.push(row.id);
          row.is_opened = true;
          this.loadOrderInfo(row);
        } else {
          this.closeRow(row);
          row.is_opened = false;
        }
      }
    },
    loadOrderInfo(row) {
      let afDecision = row.antifraud_decision;
      this.getTrace(row.id);
      this.getCP(row.id);
      this.getGoods(row.id);
      if (afDecision != null) this.getAFRules(row.id);
      if (row.is_split) this.getSplit(row.id);
    },
    closeRow(row) {
      var index = this.openedDetailed.indexOf(row.id);
      if (index >= 0) {
        this.openedDetailed.splice(index, 1);
      }
      row.is_opened = false;
      if (this.traceList.hasOwnProperty(row.id)) delete this.traceList[row.id];
      if (row.antifraud_decision != null)
        if (this.rulesList.hasOwnProperty(row.id))
          delete this.rulesList[row.id];
      if (row.is_split)
        if (this.splitList.hasOwnProperty(row.id))
          delete this.splitList[row.id];
    },
    getCustomParams(field, cp, id) {
      if (!_.isEmpty(cp)) {
        let data = cp.find(el => el.k == field);
        if (data != undefined) return data.v;
      } else {
        return "";
      }
    },
    rowClassDetails(row, index) {
      if (row && this.openedDetailed.indexOf(row.id) != -1) {
        row.is_opened = true;
        return this.rowStyle(row.state_id);
      } else return "";
    },
    showOptionButtons(state) {
      let isAdmin = this.getProfile.is_admin;
      if (isAdmin) return true;
      else {
        let rights = this.getRights;
        if (rights.length > 0) {
          if (
            state == 3 &&
            (!(rights.indexOf("charge") == -1) ||
              !(rights.indexOf("unblock") == -1))
          )
            return true;
          else if ((state == 8 || state == 20) && !(rights.indexOf("refund") == -1)) return true;
          else if (!(rights.indexOf("state_change") == -1)) return true;
          else if (!(rights.indexOf("actualize_transaction") == -1)) return true;
          else return false;
        } else return false;
      }
    },
    imgSrc(code) {
      const url = "https://static-stage.mapcard.pro/static/bo/images/flags/";
      code = code != undefined && code != null && code != "" ? code : "ZZ";
      return url + code.toLowerCase() + ".png";
    },
    saveColumns() {
      let now = new Date();
      localStorage.setItem("Date_columns", now.getTime());
      localStorage.setItem("columns", JSON.stringify(this.columnsTemplate));
    },
    bottomVisible() {
      const scrollY = window.scrollY;
      this.scrollValue = scrollY;
      const visible = document.documentElement.clientHeight;
      const pageHeight = document.documentElement.scrollHeight;
      const bottomOfPage = visible + scrollY >= pageHeight;
      return bottomOfPage || pageHeight < visible;
    },
    topVisible() {
      const scrollY = window.scrollY;
      return scrollY == 0;
    },
    scrollBottom() {
      const scrollY = window.scrollY;
      const st = scrollY >= 190 ? true : false;
      return st;
    },
    openChargeDialog(id, amount, currency) {
      this.$set(this.chargeTransactionInfo, "id", id);
      this.$set(this.chargeTransactionInfo, "amount", amount);
      this.$set(this.chargeTransactionInfo, "currency", currency);
      this.$set(this.chargeTransactionInfo, "goods", this.getListOfGoods(id));
      this.$set(this.chargeTransactionInfo, "cp", this.getListOfCP(id));
      this.showDialogCharge = true;
    },
    closeChargeDialog() {
      this.showDialogCharge = false;
      this.transactionInfo = null;
    }
  },
  beforeMount() {
		this.$store.dispatch("getTerminal").then(() => {
			this.$store.dispatch("getCustomParams");
			this.customP = this.customParams;
			this.flag_cp = true;
		});
		this.$store.dispatch("getProcessing");
		this.$store.dispatch("getRules");
		this.$store.dispatch("getMerchant");
    if (
      localStorage.getItem("filters") == null &&
      localStorage.getItem("filters") == undefined
    )
      this.loadAsyncData();
  },
	created() {
    window.addEventListener("scroll", () => {
      this.isRefresh = false;
      this.bottom = this.bottomVisible();
      this.top = this.topVisible();
      this.scrollFromTop = this.scrollBottom();
    });
  },
  computed: {
    ...mapGetters([
      "getProfile",
      "getRights",
      "merchantList",
      "merchantName",
      "terminalList",
      "terminalName",
      "terminalTax",
      "customParams",
      "processingList",
      "processingName",
      "processingIcon",
      "statusList",
      "decisionList",
      "decisionName",
      "decisionStyle",
      "cardClass",
      "cardName",
      "holderImg",
      "customParams",
      "decisionAF",
      "afruleName",
      "currencyCharacter",
      "countryNameRu",
      "statusName",
      "statusStyle",
      "rowStyle"
    ]),
    controlColumns() {
      let columnsTemplatetemp = [];
      if (localStorage.getItem("columns")) {
        columnsTemplatetemp = JSON.parse(localStorage.getItem("columns"));
        const columnFZ = columnsTemplatetemp.find(
          el => el.field == "is_receipt"
        );
        if (columnFZ) columnFZ.title = "Чек";
      }

      let cp = [];
      if (this.customParams.length > 0) {
        cp = _.map(this.customParams, el => {
          return {
            title: el.name,
            field: el.key,
            visible: false,
            centered: false,
            is_cp: true
          };
        });
      }
      this.columnsTemplate = _.uniq(
        _.union(this.columnsTemplate, cp),
        false,
        el => el.field
      );
      this.columnsTemplate.forEach((el, index) => {
        if (el.field == "antifraud_decision") el.visible = this.decisionAF;
        let findItem = columnsTemplatetemp.find(i => i.field == el.field);
        if (!findItem) columnsTemplatetemp.splice(index, 0, el);
      });

      if (columnsTemplatetemp.length == this.columnsTemplate.length) {
        this.columnsTemplate = columnsTemplatetemp;
      } else {
        if (columnsTemplatetemp.length > this.columnsTemplate.length) {
          let tempArray = columnsTemplatetemp;
          tempArray.forEach((el, index) => {
            let temp = this.columnsTemplate.filter(
              item => item.field == el.field
            ).length;
            if (temp == 0) {
              columnsTemplatetemp = columnsTemplatetemp.filter(
                q => q.field != el.field
              );
            }
          });
          this.columnsTemplate = columnsTemplatetemp;
        } else if (columnsTemplatetemp.length < this.columnsTemplate.length) {
          this.columnsTemplate.forEach((el, index) => {
            let tp = columnsTemplatetemp.filter(item => item.field == el.field)
              .length;
            if (tp == 0) columnsTemplatetemp.splice(index, 0, el);
          });
          this.columnsTemplate = columnsTemplatetemp;
        }
        this.saveColumns();
      }
      return this.columnsTemplate;
    },
    emptyDataTable() {
      if (this.data.length == 0 && this.loading) return "Загрузка данных";
      return "Нет данных";
    }
  },
  watch: {
    bottom(bottom) {
      let needLoad = this.data.length % this.defParam.limit == 0;
      if (bottom && this.direction == "down" && !this.isRefresh && needLoad) {
        if (this.data.length > 0) {
          this.defParam = _.omit(this.defParam, "order_id_up");
          this.defParam.order_id_down = this.data[this.data.length - 1]["id"];
          this.defParam.order = "desc";
        }
        this.loadAsyncData(null, "loadbot");
      }
    },
    top(top) {
      if (top && this.direction == "up" && !this.isRefresh) {
        if (this.delCount > 0) {
          this.defParam = _.omit(this.defParam, "order_id_down");
          if (this.data.length > 0) {
            this.defParam.order_id_up = this.data[0]["id"];
            this.defParam.order = "asc";
          }
          this.loadAsyncData(null, "loadtop");
        }
      }
    },
    scrollValue(nscrollValue, scrollValue) {
      if (scrollValue && nscrollValue) {
        this.direction = scrollValue < nscrollValue ? "down" : "up";
      }
    }
  },
  components: {
    ActualizeState,
    VisualSearch,
    OrderInfo,
    StatusHistory,
    AntifraudRules,
    OrderSplit,
    refundDialog,
    chargeDialog,
    unlockDialog,
    changeStatusDialog,
    VuePerfectScrollbar
  }
};
</script>

<style lang="sass">
.dropdown
  .vb
    height: 300px
  .dropdown-item
    padding: 0.2rem 1rem
    label
      margin-bottom: 0px
.onebyone
  font-size: 11px !important
  margin-bottom: 0px
</style>
